import React from 'react';
import TenantManager from '../../../../components/tenantManager';
import tenants from './tenants';

class TimesheetsList extends React.Component {
    render() {
        return <TenantManager {...tenants} {...this.props} />;
    }
}

export default TimesheetsList;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/lists/timesheets/index.jsx